import actions from '../constants/External';

export function relayExternalApiCall(params) {
  return {
    type: actions.RELAY_EXTERNAL_API_CALL,
    data: {
      params,
    },
  };
}
